/* @ngInject */

export default (
  $q,
  $rootScope,
  $scope,
  webpage,
  eventService,
  navigationService,
  organizationService,
  contactsService,
  mergeFieldsService,
  changesService,
  uiService,
  ORGANIZATION,
  CONTACT
) => {
  $scope.Model = {
    availableContacts: [],
    contactsList: null,
    mergeFields: [],
    isReady: false
  };

  /*
   * Initialize controller and start loading the required data
   * --------------------------------------------------------------------------------
   */
  webpage.pageTitle('Loading, please wait');
  if ($rootScope.CurrentAccount.isAdministrator) {
    $q.all([
      organizationService.readOrganization({ id: $rootScope.CurrentOrganization.id }),
      contactsService.getWithClientAccess({ fields: CONTACT.FIELDS.WTF_LIST }),
      mergeFieldsService.getFields(false)
    ])
      .then(function (data) {
        // Overwrite $rootScope values in case they've reverted to values within Token
        $rootScope.CurrentOrganization.features.configClientPortal =
          data[0].features.configClientPortal;
        // Set Model values
        $scope.Model.availableContacts = data[1];
        $scope.Model.mergeFields = data[2];
      })
      .then(function () {
        // Declare Model as Ready and start rendering the page
        webpage.pageTitle('Client Portal : Settings');
        $scope.Model.isReady = true;
      });
  }

  /*
   * Methods available in Controller Scope
   * --------------------------------------------------------------------------------
   */
  $scope.listReady = function (list) {
    $scope.Model.contactsList = list;
  };
  $scope.editInvitationContent = function () {
    eventService.dialogTextEdit({
      id: 'invitation',
      title: 'Edit E-Mail invitation content',
      content: $rootScope.CurrentOrganization.features.configClientPortal.system.invite.content,
      mergeProperties: $scope.Model.mergeFields,
      plainText: true
    });
  };

  $scope.editNotificationDealStageChangeEmail = function () {
    eventService.dialogTextEdit({
      id: 'dealStageChangeEmail',
      title: 'Edit deal changes stage notification E-Mail',
      content:
        $rootScope.CurrentOrganization.features.configClientPortal.notifications.dealStageChange
          .emailContent,
      mergeProperties: null,
      plainText: true
    });
  };

  $scope.editNotificationDealStageChangeSms = function () {
    eventService.dialogTextEdit({
      id: 'dealStageChangeSms',
      title: 'Edit deal changes stage notification SMS',
      content:
        $rootScope.CurrentOrganization.features.configClientPortal.notifications.dealStageChange
          .smsContent,
      mergeProperties: null,
      plainText: true
    });
  };

  $scope.editNotificationNewSharedNoteEmail = function () {
    eventService.dialogTextEdit({
      id: 'newSharedNoteEmail',
      title: 'Edit new shared note notification E-Mail',
      content:
        $rootScope.CurrentOrganization.features.configClientPortal.notifications.newNote
          .emailContent,
      mergeProperties: null,
      plainText: true
    });
  };

  $scope.editNotificationNewSharedNoteSms = function () {
    eventService.dialogTextEdit({
      id: 'newSharedNoteSms',
      title: 'Edit new shared note notification SMS',
      content:
        $rootScope.CurrentOrganization.features.configClientPortal.notifications.newNote
          .smsContent,
      mergeProperties: null,
      plainText: true
    });
  };

  $scope.editNotificationNewSharedFileEmail = function () {
    eventService.dialogTextEdit({
      id: 'newSharedFileEmail',
      title: 'Edit new shared file notification E-Mail',
      content:
        $rootScope.CurrentOrganization.features.configClientPortal.notifications.newFile
          .emailContent,
      mergeProperties: null,
      plainText: true
    });
  };

  $scope.editNotificationNewSharedFileSms = function () {
    eventService.dialogTextEdit({
      id: 'newSharedFileSms',
      title: 'Edit new shared file notification SMS',
      content:
        $rootScope.CurrentOrganization.features.configClientPortal.notifications.newFile
          .smsContent,
      mergeProperties: null,
      plainText: true
    });
  };

  $scope.editNotificationNewDocumentRequestEmail = function () {
    eventService.dialogTextEdit({
      id: 'newDocumentRequestEmail',
      title: 'Edit new document request notification E-Mail',
      content:
        $rootScope.CurrentOrganization.features.configClientPortal.notifications
          .newDocumentRequest.emailContent,
      mergeProperties: null,
      plainText: true
    });
  };

  $scope.editNotificationNewDocumentRequestSms = function () {
    eventService.dialogTextEdit({
      id: 'newDocumentRequestSms',
      title: 'Edit new document request notification SMS',
      content:
        $rootScope.CurrentOrganization.features.configClientPortal.notifications
          .newDocumentRequest.smsContent,
      mergeProperties: null,
      plainText: true
    });
  };

  $scope.editNotificationDocumentRequestDueEmail = function () {
    eventService.dialogTextEdit({
      id: 'documentRequestDueEmail',
      title: 'Edit requested document due date reached notification E-Mail',
      content:
        $rootScope.CurrentOrganization.features.configClientPortal.notifications
          .documentRequestDue.emailContent,
      mergeProperties: null,
      plainText: true
    });
  };

  $scope.editNotificationDocumentRequestDueSms = function () {
    eventService.dialogTextEdit({
      id: 'documentRequestDueSms',
      title: 'Edit requested document due date reached notification SMS',
      content:
        $rootScope.CurrentOrganization.features.configClientPortal.notifications
          .documentRequestDue.smsContent,
      mergeProperties: null,
      plainText: true
    });
  };

  $scope.editNotificationMissingDocumentRequestEmail = function () {
    eventService.dialogTextEdit({
      id: 'missingDocumentRequestEmail',
      title: 'Edit requested document missing reminder E-Mail',
      content:
        $rootScope.CurrentOrganization.features.configClientPortal.notifications
          .missingDocumentRequest.emailContent,
      mergeProperties: null,
      plainText: true
    });
  };

  $scope.editNotificationMissingDocumentRequestSms = function () {
    eventService.dialogTextEdit({
      id: 'missingDocumentRequestSms',
      title: 'Edit requested document missing reminder SMS',
      content:
        $rootScope.CurrentOrganization.features.configClientPortal.notifications
          .missingDocumentRequest.smsContent,
      mergeProperties: null,
      plainText: true
    });
  };

  $scope.editUrlVideo = function () {
    eventService.dialogUrlEdit({
      id: 'video',
      title: 'Edit URL for overview video',
      content:
        $rootScope.CurrentOrganization.features.configClientPortal.display.sidebarOverviewVideo
          .url
    });
  };

  $scope.editUrlPrivacy = function () {
    eventService.dialogUrlEdit({
      id: 'privacy',
      title: 'Edit URL for privacy disclosure',
      content: $rootScope.CurrentOrganization.features.configClientPortal.display.privacy.url
    });
  };

  $scope.editClientProfileFullVersion = function () {
    eventService.dialogClientProfileVersionEdit({
      id: 'full',
      title: 'Full version of Client Profile',
      content:
        $rootScope.CurrentOrganization.features.configClientPortal.display
          .clientProfileFullVersion.wizard
    });
  };

  $scope.editClientProfileCustomVersion = function () {
    eventService.dialogClientProfileVersionEdit({
      id: 'custom',
      title: 'Edit custom version of Client Profile',
      content:
        $rootScope.CurrentOrganization.features.configClientPortal.display
          .clientProfileCustomVersion.wizard
    });
  };

  $scope.textEdited = function (_params) {
    switch (_params.id) {
      case 'invitation':
        $rootScope.CurrentOrganization.features.configClientPortal.system.invite.content =
          _params.content;
        break;
      case 'dealStageChangeEmail':
        $rootScope.CurrentOrganization.features.configClientPortal.notifications.dealStageChange.emailContent =
          _params.content;
        break;
      case 'dealStageChangeSms':
        $rootScope.CurrentOrganization.features.configClientPortal.notifications.dealStageChange.smsContent =
          _params.content;
        break;
      case 'newSharedNoteEmail':
        $rootScope.CurrentOrganization.features.configClientPortal.notifications.newNote.emailContent =
          _params.content;
        break;
      case 'newSharedNoteSms':
        $rootScope.CurrentOrganization.features.configClientPortal.notifications.newNote.smsContent =
          _params.content;
        break;
      case 'newSharedFileEmail':
        $rootScope.CurrentOrganization.features.configClientPortal.notifications.newFile.emailContent =
          _params.content;
        break;
      case 'newSharedFileSms':
        $rootScope.CurrentOrganization.features.configClientPortal.notifications.newFile.smsContent =
          _params.content;
        break;
      case 'newDocumentRequestEmail':
        $rootScope.CurrentOrganization.features.configClientPortal.notifications.newDocumentRequest.emailContent =
          _params.content;
        break;
      case 'newDocumentRequestSms':
        $rootScope.CurrentOrganization.features.configClientPortal.notifications.newDocumentRequest.smsContent =
          _params.content;
        break;
      case 'documentRequestDueEmail':
        $rootScope.CurrentOrganization.features.configClientPortal.notifications.documentRequestDue.emailContent =
          _params.content;
        break;
      case 'documentRequestDueSms':
        $rootScope.CurrentOrganization.features.configClientPortal.notifications.documentRequestDue.smsContent =
          _params.content;
        break;
      case 'missingDocumentRequestEmail':
        $rootScope.CurrentOrganization.features.configClientPortal.notifications.missingDocumentRequest.emailContent =
          _params.content;
        break;
      case 'missingDocumentRequestSms':
        $rootScope.CurrentOrganization.features.configClientPortal.notifications.missingDocumentRequest.smsContent =
          _params.content;
        break;
      default:
        break;
    }
    $scope.toggleChanges();
  };

  $scope.urlEdited = function (_params) {
    switch (_params.id) {
      case 'video':
        $rootScope.CurrentOrganization.features.configClientPortal.display.sidebarOverviewVideo.url =
          _params.content;
        break;
      case 'privacy':
        $rootScope.CurrentOrganization.features.configClientPortal.display.privacy.url =
          _params.content;
        break;
      default:
        break;
    }
    $scope.toggleChanges();
  };

  $scope.toggleProfileCustomVersion = function () {
    if (
      !$rootScope.CurrentOrganization.features.configClientPortal.display
        .clientProfileCustomVersion.visible
    ) {
      $rootScope.CurrentOrganization.features.configClientPortal.display.clientProfileCustomVersion.wizard = [
        1
      ];
    }
    $scope.toggleChanges();
  };
  $scope.clientProfileVersionEdited = function (_params) {
    switch (_params.id) {
      case 'custom':
        $rootScope.CurrentOrganization.features.configClientPortal.display.clientProfileCustomVersion.wizard =
          _params.content;
        break;
      default:
        break;
    }
    $scope.toggleChanges();
  };

  $scope.toggleChanges = function () {
    changesService.change();
  };

  /*
   * Register and configure Changes service
   * --------------------------------------------------------------------------------
   */
  changesService.init({ useFinishOnInterval: true });
  changesService.onFinish(saveChanges);

  function saveChanges() {
    var organizationData = {
      id: $rootScope.CurrentOrganization.id,
      features: {
        configClientPortal: $rootScope.CurrentOrganization.features.configClientPortal
      }
    };
    return organizationService.updateOrganization(organizationData).then(function (result) {
      if (result.status) {
        navigationService.organizationChange({
          idOrganization: $rootScope.CurrentOrganization.id
        });
        changesService.resetChanges();
      } else {
        uiService.toast({
          text: {
            p1: 'Failed to',
            p2: 'save',
            p3: 'your changes'
          },
          warn: true
        });
      }
      return { status: !!result.status };
    });
  }
};
